export enum QDVSPlanCodes {
  QDVSGOLD = 'QDVSGOLD',
  QDVSPLAT = 'QDVSPLAT',
  QDVSPWTR = 'QDVSPWTR',
}

export enum QDVSPlans {
  QDVSGOLD = 'QDVS GOLD',
  QDVSPLAT = 'QDVS PLATINUM',
  QDVSPWTR = 'QDVS POWERTRAIN',
}
